<template>
  <modal classes="w-full mx-auto overflow-auto max-w-xs lg:max-w-125 bg-white"
         @close="$emit('close')">
    <div class="pt-4 lg:pt-8 pb-6 px-6 lg:px-12 text-center text-main-text">
      <slot name="title"></slot>
      <p class="text-xs lg:text-sm my-2">{{description}}</p>
      <div class="flex justify-between mt-4 lg:mt-8">
        <button @click="$emit('firstButtonClick')" :class="button1.classes" v-if="button1">{{button1.text}}</button>
        <button @click="$emit('secondButtonClick')" :class="button2.classes" v-if="button2">{{button2.text}}</button>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from '@/views/modals/new-base-modal.vue';

export default {
  name: 'TwoButtonsBaseModal',
  components: { Modal },
  props: ['title', 'description', 'button1', 'button2'],
};
</script>
<style scoped>

</style>
